import { STUDIO_COMP_REF_TYPE } from '../consts';
import { isClassicEditorHost } from './get-editor-host';
export const getCompRefType = (editorHost, breakpointId) => {
  return (isClassicEditorHost(editorHost) ? breakpointId : STUDIO_COMP_REF_TYPE) ?? STUDIO_COMP_REF_TYPE;
};
//# sourceMappingURL=get-comp-ref-type.js.map